import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { GoogleMapsComponent } from '../google-maps.component';
import { GoogleMapsModule } from './google-maps.module';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, FormsModule, IonicModule, GoogleMapsModule, TranslateModule.forChild()],
  declarations: [GoogleMapsComponent],
  exports: [GoogleMapsComponent]
})
export class GoogleMapsComponentModule {}
